<template>
  <b-card class="no-border animated">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2"><b-badge variant="info">{{detailedInfo.state}}</b-badge> Shipment-{{number}}</h5>
      <div class="pull-right">
        <b-dropdown @click="showModalDelete()" right split text="Remove" variant="outline-danger">
          <b-dropdown-item @click="showModalDelete(true)">Remove only shipment</b-dropdown-item>
        </b-dropdown>
        <b-button variant="outline-primary" v-show="detailedInfo.state == 'CREATED'" @click="section = 'edit'"><i class="fa fa-pencil-square-o"></i>&nbsp; Edit</b-button>
        <b-button variant="outline-success" v-show="detailedInfo.state == 'CREATED'" @click="showUpdateModal = true"><i class="fa fa-play"></i>&nbsp; Start Load</b-button>
      </div>
    </div>
    <div class="list-group mb-2">
      <b-nav>
        <b-nav-item @click="section = ''"           :active="section === ''"           >Detail</b-nav-item>
        <b-nav-item @click="section = 'orders'"     :active="section === 'orders'"     >Jobs</b-nav-item>
        <!-- <b-nav-item @click="section = 'additional'" :active="section === 'additional'" >Additional Data</b-nav-item> -->
      </b-nav>
    </div>
    <b-modal
      id="delete_shipment"
      title="Delete Shipment"
      v-model="showDeleteModal"
      header-bg-variant="danger"
      ok-variant="danger"
      @ok="deleteShipment()">
      <p class="my-4">Are you sure want to delete this shipment ?</p>
      <small v-if="!deleteOnlyShipment" class="form-text text-muted">
        This will delete all order(s) linked to the shipment.<br>
        <strong>This action can't be undone.</strong>
      </small>
    </b-modal>
    <b-modal
      id="update_shipment"
      title="Update Shipment State"
      v-model="showUpdateModal"
      header-bg-variant="warning"
      ok-variant="warning"
      @ok="startLoad()">
      <p class="my-4">Are you sure want to start load this shipment ?</p>
    </b-modal>
    <router-view></router-view>
  </b-card>
</template>
<script>
export default {
  name: 'shipment_detail',
  data() {
    const routes = this.$route.fullPath.split('/');
    return {
      section: routes[4] || '',
      loaded: false,
      showDeleteModal: false,
      deleteOnlyShipment: false,
      showUpdateModal: false,
    };
  },
  created() {
    const { shipmentId } = this.$route.params;
    this.$store.commit('shipment_md/shipments/SET_DETAIL_ID', shipmentId);
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
      { to: 'shipments', name: 'Shipments' },
      { to: shipmentId, name: 'Detail' },
    ]);
    this.$store.dispatch('shipment_md/shipments/LOAD_DETAIL_DATA');
  },
  computed: {
    detailedInfo() {
      return this.$store.getters['shipment_md/shipments/get_detail_data'];
    },
    number() {
      return this.detailedInfo.number;
    },
  },
  watch: {
    section(newSection) {
      const { shipmentId } = this.$route.params;
      this.$router.push(`/shipment_md/shipments/${shipmentId}/${newSection}`);
      this.$store.dispatch('shipment_md/shipments/LOAD_DETAIL_DATA');
    },
  },
  methods: {
    deleteShipment() {
      const { shipmentId } = this.$route.params;
      if (this.deleteOnlyShipment) {
        this.$store.dispatch('shipment_md/shipments/DELETE_DATA').then((ok) => {
          if (ok) this.$router.push('/shipment_md/shipments');
        });
      } else {
        this.$store.dispatch('shipment_md/orders/DELETE_DATA_BY_SHIPMENT', shipmentId).then((delOkOrder) => {
          this.$store.dispatch('shipment_md/shipments/DELETE_DATA').then((delOkShipment) => {
            if (delOkShipment || delOkOrder) this.$router.push('/shipment_md/shipments');
          });
        });
      }
    },
    showModalDelete(isOnlyShipment = false) {
      this.showDeleteModal = true;
      this.deleteOnlyShipment = isOnlyShipment;
    },
    startLoad() {
      const data = {
        id: this.detailedInfo.id,
        state: 'READY_TO_LOAD',
      };
      this.$store.dispatch('shipment_md/shipments/UPDATE_SHIPMENT_STATE', data).then(() => this.$router.go());
    },
  },
};
</script>
<style>

</style>




// WEBPACK FOOTER //
// src/views/pages/shipment_md/shipments/Detail.vue